import script from "./api-response.vue?vue&type=script&setup=true&lang=js"
export * from "./api-response.vue?vue&type=script&setup=true&lang=js"

import "./api-response.vue?vue&type=style&index=0&id=06abad74&lang=css"

const __exports__ = script;

export default __exports__